import { useEffect, useState } from 'react';

import { TMainpageBrandContext } from '../NewAdfoxBanner/bannerTypes';
import { useApplicationContext } from '../../utils/applicationContext';
import { fetchGetMainPageBrandBannerEnrichmentsService } from '../../services/adBanner';
import { IV1GetMainPageBrandBannerEnrichmentsResponse } from '../../repositories/ad-banner/entities/get_main_page_brand_banner_enrichments_v1/V1GetMainPageBrandBannerEnrichmentsResponse';
import { noop } from 'lodash';

/**
 * @description Используется для обогащения данных баннера для типа mainpageBrand
 * не использует редакс для получения и хранения данных, так как данные слишком локальные и не нужны для других компонентов
 */
export function useMainPageBrandBannerEnrichments({
  objectId,
  objectType,
  dealType,
  useServerEnrichment,
  isApartment,
  newBuildingId,
}: TMainpageBrandContext): null | IV1GetMainPageBrandBannerEnrichmentsResponse {
  const context = useApplicationContext();

  const [serverData, setServerData] = useState<IV1GetMainPageBrandBannerEnrichmentsResponse | null>(null);

  useEffect(() => {
    /**
     * @deprecated Нужно спросить у постановок, когда будет выпилено из контекста, им нужно перейти на objectId
     */
    const newBuildingIdInt = newBuildingId ? parseInt(newBuildingId, 10) : null;

    const objectIdInt = objectId ? parseInt(objectId, 10) : null;

    if (useServerEnrichment === '1' && objectIdInt) {
      fetchGetMainPageBrandBannerEnrichmentsService(context, {
        objectId: objectIdInt,
        dealType,
        objectType,
        isApartment: isApartment === '1',
      }).then(
        data => setServerData(data),
        // Тут ничего не делаем, так как в сервисе у нас всё уже залоггировано и обработано
        noop,
      );
    } else if (
      /**
       * @deprecated Нужно спросить у постановок, когда будет выпилено из контекста, им нужно перейти на objectId.
       * Тут нужно удалить этот блок полностью
       */
      !objectIdInt &&
      newBuildingIdInt
    ) {
      fetchGetMainPageBrandBannerEnrichmentsService(context, {
        objectId: newBuildingIdInt,
        isApartment: isApartment === '1',
      }).then(
        data => setServerData(data),
        // Тут ничего не делаем, так как в сервисе у нас всё уже залоггировано и обработано
        noop,
      );
    }
    /**
     * @description изменение данных не должно триггерить запрос
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return serverData;
}
